@if (show()) {
  <div class="disclosure-approval-banner" role="status">
    <div class="disclosure-approval-banner__icon" aria-hidden="true">
      <img src="/public/svgs/bell.svg" alt="" width="18" height="18" />
    </div>

    <p class="disclosure-approval-banner__text">
      {{ messageKey() | translate: messageParams() }}
    </p>

    <div class="disclosure-approval-banner__actions">
      <button
        type="button"
        class="disclosure-approval-banner__cta"
        (click)="openApprovals()"
      >
        {{ 'app.identity.disclosure.banner.cta' | translate }}
      </button>
      <button
        type="button"
        class="disclosure-approval-banner__dismiss"
        (click)="dismiss()"
        [attr.aria-label]="'app.identity.disclosure.banner.dismissAria' | translate"
      >
        {{ 'app.identity.disclosure.banner.dismiss' | translate }}
      </button>
    </div>
  </div>
}
